import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CognitoUserService } from '../services/cognito-user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private catchitUserService: CognitoUserService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isAdmin = await this.catchitUserService.isAdminOrSuperAdminForAnyArea();

    if (!isAdmin) {
      await this.router.navigate(['/error/403']);
      return false;
    }

    return true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {
  constructor(
    private catchitUserService: CognitoUserService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isSuperAdmin = await this.catchitUserService.isSuperAdmin();

    if (!isSuperAdmin) {
      await this.router.navigate(['/error/403']);
      return false;
    }

    return true;
  }
}